import React from 'react'
import PropTypes from 'prop-types'
import {StyledPasswordValidation, Dot, StyledStageBox, StageLabel} from './PasswordForm.styled';


const PasswordValidation = ({minCharacters, lowerCase, upperCase}) => {

  const validationStages = [
    {
      state: minCharacters,
      content: '6 characters',
      dataId: 'minCharacters'
    },
    {
      state: lowerCase,
      content: '1 lowercase',
      dataId: 'lowerCase'
    },
    {
      state: upperCase,
      content: '1 uppercase',
      dataId: 'upperCase'
    },
  ];

  return (
    <StyledPasswordValidation >
      {validationStages.map((stage) => (
        <StyledStageBox data-testid={stage.dataId} key={stage.content}>
          <Dot state={stage.state}/>
          <StageLabel>{stage.content}</StageLabel>
        </StyledStageBox>
      ))}
    </StyledPasswordValidation>
  )
};

PasswordValidation.propTypes = {
  lowerCase: PropTypes.bool,
  minCharacters: PropTypes.bool,
  upperCase: PropTypes.bool,
}
;
export default PasswordValidation;
